import { inject } from '@angular/core';
import { HttpResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

export const SnackbarInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);
  return next(req).pipe(
    tap({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (resp: any) => {
        if (
          (req.method == 'POST' || req.method == 'PUT') &&
          !req.url.includes('getAccessToken')
        )
          if (
            resp instanceof HttpResponse &&
            resp.status === 200 &&
            resp.body &&
            typeof resp.body.message === 'string' &&
            resp.body.message.trim() !== ''
          ) {
            snackBar.open(`${resp.body.message}`, undefined, {
              duration: 6000,
            });
          }
      },
      error: (error) => {
        if (!req.url.includes('getAccessToken')) {
          snackBar.open(`${error.status} ${error.error.message}`, undefined, {
            duration: 6000,
          });
        } else {
          snackBar.open(
            'Neispravno korisničko ime ili lozinka. Pokušajte ponovo.',
            undefined,
            {
              duration: 6000,
              panelClass: ['snackbar', 'snackbar-info'],
            }
          );
        }
        console.error(error);
      },
    })
  );
};
